import moment from 'moment'
import 'moment/locale/ja'

export const FULL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const SHORT_DATETIME_FORMAT = 'YYYY-MM-DD'
export const MED_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm'
export const JP_DATETIME_FORMAT = 'YYYY年M月D日, h:mm a Z'

let latestTZOffset = undefined

export class DateHelper {
  static str2moment(datetime) {
    let dt = datetime

    moment.locale('en')
    // i18n.language === "ja" ? moment.locale('ja') : moment.locale('en')

    let mmt = moment.parseZone(dt)
    if (!dt && latestTZOffset) { // now
      mmt.utcOffset(latestTZOffset)
    }

    return mmt
  }

  static output(datetime, target_format = FULL_DATETIME_FORMAT) {
    let mmt = datetime
    if (!mmt || typeof mmt.format !== 'function') {
      mmt = this.str2moment(mmt)
    }

    latestTZOffset = mmt.format('Z')

    // return mmt.format(i18n.language == "ja" ? JP_DATETIME_FORMAT : DATETIME_FORMAT)
    return mmt.format(target_format)
  }

  static startOfCurrentMonth() {
    return moment().startOf('month').toDate()
  }

  static endOfCurrentMonth() {
    return moment().endOf('month').toDate();
  }

  static diffFromNow(date, unit='days'){
    if(typeof(date) === 'string')
      date = moment(date)

    return moment().diff(date, unit)
  }
}
